import { useContext } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  const { trackEvent } = context;

  const trackEventAndGo = (ev, eventName, eventData = {}, hrefOverride = '') => {
    ev.preventDefault();
    const href = hrefOverride || ev?.target?.href || '/';
    trackEvent(`user platform - header - ${eventName}`, eventData);
    window.location.href = href;
  };

  return {
    trackEvent,
    trackEventAndGo,
  };
};

export default useAnalytics;
